import type { DataTableColumn } from 'naive-ui'
import { t } from '@/locales'

const columns: DataTableColumn<Knowledge.Row>[] = [
  {
    title: 'STT',
    key: 'index',
    width: 70,
    sorter: false,
    resizable: true,
  },
  {
    title: t('classroom.name'),
    key: 'name',
    width: 200,
    sorter: false,
    resizable: true,
  },
  {
    title: t('classroom.numberMember'),
    key: 'doc_form',
    width: 150,
    sorter: false,
    resizable: true,
  },
  {
    title: '',
    key: 'actions',
    width: 80,
  },
]
export default columns
